/* eslint-disable security/detect-object-injection -- dynamic env key lookup is intentional */
const isVite = typeof import.meta !== "undefined" && !!import.meta.env;
const env = isVite ? import.meta.env : typeof process !== "undefined" ? process.env : {};

export const getEnv = (key, fallback = null) => {
    if (isVite) {
        const viteKey = key.startsWith("VUE_APP_") ? "VITE_" + key.slice("VUE_APP_".length) : key;
        return env[viteKey] ?? fallback;
    }
    return env[key] ?? fallback;
};

export const getBaseUrl = () => (isVite ? (import.meta.env.BASE_URL ?? "/") : (env.BASE_URL ?? "/"));

export const getNodeEnv = () => (isVite ? import.meta.env.MODE : env.NODE_ENV);
